import styled from '@emotion/styled';
import {
  BREAKPOINT_MEDIUM,
  BREAKPOINT_SMALL,
  COLOR_GREEN,
} from 'client/components/MarketingPagesShared/styles';

const Section = styled.section`
  background: ${COLOR_GREEN};
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1060px;
  margin: auto;
  padding: 100px 25px;
  img,
  picture {
    flex: 0 0 431px;
  }
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    flex-direction: column;
    img,
    picture {
      flex: 0 0 320px;
    }
  }
  @media (max-width: 600px) {
    padding-bottom: 60px;
    img,
    picture {
      width: 100%;
    }
  }
`;

const TextContainer = styled.div`
  margin-right: 124px;
  color: white;
  h2 {
    margin: 0;
    font-weight: 900;
    font-size: 3.6rem;
  }
  p {
    margin: 24px 0 0 0;
    color: white;
    font-size: 1.8rem;
  }
  @media (max-width: ${BREAKPOINT_MEDIUM}px) {
    width: 100%;
    max-width: 654px;
    margin: auto;
    margin-bottom: 50px;
  }
  @media (max-width: ${BREAKPOINT_SMALL}px) {
    h2 {
      font-size: 2.8rem;
    }
  }
`;

export { Container, Section, TextContainer };
